/**
 * Gets the title for a broker, prioritizing the user-edited title if it exists
 * @param broker The broker object
 * @returns The broker's title, preferring title_user_edited if available
 */
export const getTitle = (broker?: any): string => {
  if (!broker) return '';
  
  // Return the user-edited title if it exists and is not empty
  if (broker.title_user_edited) {
    return broker.title_user_edited;
  }
  
  // Otherwise return the default title or an empty string
  return broker.title || '';
};
